import { useContext } from 'react';

import { CustomCursorContext } from '@/components/CustomCursorProvider/CustomCursorContext';

export const useCustomCursor = () => {
	const ctx = useContext(CustomCursorContext);

	if (!ctx) throw new Error('useCustomCursor must be used within CustomCursorProvider');

	return ctx;
};
